module.exports = __webpack_public_path__ + "static/core-login-7915a9901782bbc9bb19c0245012e5a6.svg";